import Header from "../../components/header/index.js";
import LeftMenu from "../../components/left-menu/index.js";
import Grid from '@mui/material/Grid';
import "./style.css";
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import React, {Component} from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField'; 
import Button from '@mui/material/Button';
import {read} from "../PIListToPaidList/api.js";
import {readEmpty} from "../PIListToPaidList/apiEmpty.js";
import Post from "../PIListToPaidList/Post.jsx";
import {useNavigate} from "react-router-dom";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import { endOfDecadeWithOptions } from "date-fns/fp";
import { editableInputTypes } from "@testing-library/user-event/dist/utils";
import PaymentDetail from "./PaymentDetail.js";

export default function CreatePost(){

    const [Caption,setCaption] = useState("")
    const [skip, setSkip] = useState(0)
    const [searchThis, setsearchThis] = useState("billTo")
    const [posts, setPosts] = useState([])
    const [isEnd,setIsEnd] = useState("loading..")
    const navigate = useNavigate();
    const [query,setQuery] = useState("")
    const [previewVisibility, setPreviewVisibility] = useState(false)
    const [loadVisibility, setLoadVisibility] = useState(false)
    const [currPreview,setCurrPreview] = useState("none")
   

    useEffect(() => {
        fetchPosts();
    }, [skip,query]);

    async function newPI(e){
        history("/proformainvoice",{state:{stuff:"new"}})

    }

    

    const fetchPosts = async () => {
        if(query.trim()){
                try{
                    const { data, error } = await read(skip,query,searchThis);
                    if(error){
                        console.log(error.message);
                        return;
                    }
        
                    if(data?.length === 0){
                        setIsEnd("Selesai...");
                        return;
                    }
                    
                    //success
                    setPosts([...posts, ...data])
                }catch(error){
                    console.log(error.message);
                }
            
        }else{

        try{
            const { data, error } = await readEmpty(skip,query);
            if(error){
                console.log(error.message);
                return;
            }

            if(data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }
            
            //success
            setPosts([...posts, ...data])
        }catch(error){
            console.log(error.message);
        } 
        }
    }

    const [fileURL, setFileURL] = useState("");
    const [openPaymentDetail, setopenPaymentDetail] = useState(false)
    const [idtoEdit,setidtoEdit] = useState("")
    const [iAmount, setIAmount] = useState();
    const [iNumb, setINumb] = useState();
    function toMonthName(monthNumber){
        const datedate = new Date();
        datedate.setMonth(monthNumber - 1);

        return datedate.toLocaleString('default', {
            month: 'long',
          });
    }
    const changeStat = async (post) => {
    
        console.log(currPreview)
        console.log(idtoEdit)
        console.log(post)
        const tanggalPembayaran = post
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/latestINum`).then(response => {
            var testestest = response.data.jumlah;
            var iAmountNow = parseInt(testestest) + 1;
            setIAmount(iAmountNow);
            var iMonth = new Date(tanggalPembayaran).getMonth()+1
            var iYear = new Date(tanggalPembayaran).getYear()+1900
            var iDate = new Date(tanggalPembayaran).getDate()
            setINumb(iYear + "." + iMonth + "-I-ZANIO." + iAmountNow);
            var INumbnow = iYear + "." + iMonth + "-I-ZANIO." + iAmountNow;
            console.log({ INumbnow, iAmountNow });
            const TotalDate = iDate + " " + toMonthName(iMonth) + " " + iYear
            return {INumbnow,iAmountNow,TotalDate}
            }).then( res => {
                const {INumbnow,iAmountNow,TotalDate} = res
                console.log("saving Invoice Status")
                axios.post(`${process.env.REACT_APP_BACKEND_URL}/updateInqOneThing`,{
                    id: currPreview.Inquiry._id, change:"PaidPILink"
                })
                axios.post(`${process.env.REACT_APP_BACKEND_URL}/updateeverythingafterpaid`, {
                    inquiryId: currPreview.Inquiry._id,
                    // optional if you have these vars in scope:
                    // author: nowstate?.user?.sales,
                    // sales:  nowstate?.user?.sales,
                    })

                console.log("thius is total date "+TotalDate)
                axios.post(`${process.env.REACT_APP_BACKEND_URL}/paidPI`,{
                    idtoEdit, tanggalPembayaran, INumbnow, iAmountNow, TotalDate, contractReq
                })})
        handleClosePaymentDetail()
        handleClosePreview()
    }

    const previewPDF = async (post) => {
        console.log(post)
        setCurrPreview(post)
        setLoadVisibility(true)
        const currid = post._id
        setidtoEdit(post._id)
    
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/previewpdf?currid=${currid}&dbwhatToPreview=proformainvoiceDB`,{
            method: "GET",
            responseType: "blob"
        }).then(resp => {
                    console.log(resp)
                        const blob = new Blob([resp.data], { type: 'application/pdf' })
                    // saveAs(blob);
                    var fileURLNew = URL.createObjectURL(blob);
                    console.log(fileURLNew)
                    setPreviewVisibility(true)
                    setLoadVisibility(false)
                    setFileURL(fileURLNew)
                })
                

            

        
        
        console.log("2")
    
    }

    const newFetchPosts = async (event) => {
        setPosts([])
        setIsEnd("Loading...");
        if(event.target.value.trim()){
        try{
            const { data, error } = await read(skip,event.target.value,searchThis);
            if(error){
                console.log(error.message);
                return;
            }

            if(data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }
            
            //success
            setPosts([...data])
        }catch(error){
            console.log(error.message);
        }
        }else{
            console.log("empty")
            try{
                const { data, error } = await readEmpty(skip,event.target.value);
                if(error){
                    console.log(error.message);
                    return;
                }
    
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                
                //success
                setPosts([...posts, ...data])
            }catch(error){
                console.log(error.message);
            } 
        }
    }

    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight } = e.target;

        if(offsetHeight + scrollTop >= scrollHeight){
            setSkip(posts?.length);
        }
    }

    const searchSelected = async (event)=>{
        setsearchThis(event.target.value)
        if(query.trim()){
            try{
                const { data, error } = await read(skip,query,event.target.value);
                if(error){
                    console.log(error.message);
                    return;
                }
    
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                
                //success
                setPosts([...data])
            }catch(error){
                console.log(error.message);
            }
            }else{
                console.log("empty")
                try{
                    const { data, error } = await readEmpty(skip,query);
                    if(error){
                        console.log(error.message);
                        return;
                    }
        
                    if(data?.length === 0){
                        setIsEnd("Selesai...");
                        return;
                    }
                    
                    //success
                    setPosts([...posts, ...data])
                }catch(error){
                    console.log(error.message);
                } 
            }
    }
    const handleSearch = (event) =>{
        setQuery(event.target.value)
        setSkip(0)
        newFetchPosts(event)
    }

    const handleClosePreview = (event) =>{
        setPreviewVisibility(false)
        setCurrPreview("none")
    }
    const history = useNavigate();

    const editPI = async (post) => {
        if(currPreview === "none"){
            history("/proformainvoice",{state:{data:post, stuff:"edit"}})
        }else{
            history("/proformainvoice",{state:{data:currPreview, stuff:"edit"}})
        }
    }

    const addonPI = async (post)=>{
        if(currPreview === "none"){
            history("/proformainvoice", {state:{data:post,stuff:"addOn"}})
        }else{
            history("/proformainvoice", {state:{data:currPreview,stuff:"addOn"}})
        }
    }

    const paidPI = (event) => {
        setopenPaymentDetail(true)
    }

    const handleClosePaymentDetail = (event) =>{
        setopenPaymentDetail(false)
    }

    const [contractReq,setContractReq] = useState();



    return <Grid xl={10.8} lg={10.6} md={10.4} sm={8.8} xs={11} sx={{mt:10, pl:2, pr:5}}>
                    <Dialog open={loadVisibility} aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "100px",  // Set your width here
                        },
                    },}}>
                    <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box>
                    </DialogContent>
                </Dialog>
                <Dialog open={openPaymentDetail} onClose={handleClosePaymentDetail} >
                    <PaymentDetail 
                     contractReq={contractReq} setContractReq={setContractReq}
                     
                     stuff="new" changeStat={changeStat} handleClose={handleClosePaymentDetail}/>
                </Dialog>
                <Dialog
                    open={previewVisibility}
                    onClose={handleClosePreview}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "1250px",  // Set your width here
                        },
                    },}}

                    
                                >
                    <DialogTitle id="alert-dialog-title">
                        <Button onClick={handleClosePreview} autoFocus>
                            <CloseIcon></CloseIcon>
                        </Button>
                    </DialogTitle>
                    <DialogContent>
                    <iframe src={fileURL} width="1200" height="500"></iframe>
                    <DialogContentText id="alert-dialog-description">
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={() => paidPI()}>
                        Paid
                    </Button>
                    
                    </DialogActions>
                </Dialog>
                    <Grid xs={12}>
                    <Grid container alignItems="center" spacing={2}>
                        <Grid item xs={4}>
                            <Select  fullWidth value={searchThis} onChange={event => searchSelected(event)}><MenuItem value="billTo">Company</MenuItem><MenuItem value="shipTo">PIC</MenuItem><MenuItem value="piAmount">No. PI</MenuItem><MenuItem value="Nominal">Nominal</MenuItem></Select>
                        </Grid>
                        <Grid item xs={8}>
                            <TextField value={query} onChange={event => handleSearch(event)} fullWidth />
                        </Grid>
                        
                        </Grid>

                            <Grid container align = "center" justify = "center" alignItems = "center">
                            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                <TableContainer sx={{ maxHeight: 500, minHeight: 440 }} className="min-h-screen h-screen overflow-scroll" onScroll={handleScroll}>
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell style={{ width: 200 }}>
                                                    Tanggal
                                                </TableCell>
                                                <TableCell>
                                                    Bill To (Company)
                                                </TableCell>
                                                <TableCell>
                                                    Bill To (PIC)
                                                </TableCell>
                                                <TableCell>
                                                    Nomor PI
                                                </TableCell>
                                                <TableCell>
                                                    Nominal
                                                </TableCell>
                                               
                                            </TableRow>
                                        </TableHead>
                                        {posts?.map((post) => (
                                            <TableBody>
                                                <TableRow hover>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.tanggalPI}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.billTo}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.shipTo}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.piAmount}</p>
                                                    </TableCell>
                                                    <TableCell>
                                                        <p>{post.grandTotal}</p>
                                                    </TableCell>
                                                    
                                                </TableRow>
                                            </TableBody>
                                        ))}
                                        {isEnd}
                                    </Table>
                                </TableContainer>
                            </Paper>
                                
                            </Grid>
                            
                            
                    </Grid>
                </Grid>    
    };

